import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Logo from '../../../assets/images/BlombosLogo.svg';
import PageHeader from '../../../components/PageHeader';
import InsuranceDetailsForm from '../../../screens/Registrationform/components/insuranceCompany';
import MedicalReferralInformation from '../../../screens/Registrationform/components/medicalReferralInformation';
import PartnerInformationForm from '../../../screens/Registrationform/components/partnerInformation';
import GuarantorInformation from '../../../screens/Registrationform/components/guarantorInformation';
import BasicDetails from '../../../screens/Registrationform/components/basicDetails';
import { getPatientDetailsApi } from '../../../api/patientApi';
import { toast } from 'sonner';
import LoadingOverlay from '../../../components/LoadingOverlay';
import ImageGalleryProfile from '../../Pages/ImageGallery';

const ViewPatient = () => {
  const [loading, setLoading] = useState(true);
  const [files, setFiles] = useState([]);
  const [patientFormData, setPatientFormData] = useState({
    basicDetails: {
      firstName: '',
      lastName: '',
      adressName: '',
      adharNumber: '',
      CityName: '',
      StateName: '',
      country: '',
      zip: '',
      gender: 'male',
      phoneNumber: '',
      occupation: '',
      employerAddress: '',
      emailAddress: '',
      DOB: '',
      maritalStatus: 'single',
      preferredLanguage: '',
      Race: '',
      Ethnicity: '',
    },
    guarantorInformation: {
      isGuarantor: 'yes',
      patientName: '',
      patientAddress: '',
      patientCity: '',
      patientPhone: '',
      patientRelation: '',
    },
    partnerInformation: {
      PartnerFirstName: '',
      PartnerLastName: '',
      PartnerOccupation: '',
      PartnerEmail: '',
      PartnerAddress: '',
      PartnerGender: 'male',
      PartnerDOB: '',
      PartnerEmergency: '',
      EmergencyAddress: '',
    },
    medicalInformation: {
      referralSource: 'Other',
      referringPhysician: '',
      referringPhysicianPhone: '',
      referringPhysicianAddress: '',
    },
    insuranceDetails: {
      InsuranceCompany: '',
      PolicyNumber: '',
      GroupNumber: '',
      ClaimsAddress: '',
      InsuranceCity: '',
      InsuranceState: '',
      InsuranceZip: '',
      Insurancephone: '',
    },
  });

  const { id } = useParams();

  useEffect(() => {
    document.body.classList.remove(
      'theme-cyan',
      'theme-purple',
      'theme-blue',
      'theme-green',
      'theme-orange',
      'theme-blush',
    );

    const fetchPatientDetails = async () => {
      try {
        const response = await getPatientDetailsApi(id);
        const data = response.data;

        console.log(data, 'patient');
        setPatientFormData({
          basicDetails: {
            firstName: data.patientDetails.firstName,
            lastName: data.patientDetails.lastName,
            adressName: data.patientDetails.address,
            adharNumber: data.patientDetails.adharNumber,
            CityName: data.patientDetails.locationDetails.city,
            StateName: data.patientDetails.locationDetails.state,
            country: data.patientDetails.locationDetails.country,
            zip: data.patientDetails.locationDetails.zip,
            gender: data.patientDetails.gender,
            phoneNumber: data.patientDetails.phone,
            occupation: data.patientDetails.companyDetails.occupation,
            employerAddress: data.patientDetails.companyDetails.name,
            emailAddress: data.patientDetails.companyDetails.email,
            DOB: data.patientDetails.dob,
            maritalStatus: data.patientDetails.maritalStatus,
            preferredLanguage: data.patientDetails.preferredLanguage,
            Race: data.patientDetails.race,
            Ethnicity: data.patientDetails.ethnicity,
          },
          guarantorInformation: {
            isGuarantor: data.patientDetails.isSelfGuarantor ? 'yes' : 'no',
            patientName: data.patientDetails.guarantorDetails.name,
            patientAddress: data.patientDetails.guarantorDetails.address,
            patientCity: data.patientDetails.guarantorDetails.city,
            patientPhone: data.patientDetails.guarantorDetails.phoneNumber,
            patientRelation: data.patientDetails.guarantorDetails.relationship,
          },
          partnerInformation: {
            PartnerFirstName: data.patientDetails.partnerDetails.firstName,
            PartnerLastName: data.patientDetails.partnerDetails.lastName,
            PartnerOccupation: data.patientDetails.partnerDetails.occupation,
            PartnerEmail: data.patientDetails.partnerDetails.email,
            PartnerAddress: data.patientDetails.partnerDetails.address,
            PartnerGender: data.patientDetails.partnerDetails.gender,
            PartnerDOB: data.patientDetails.partnerDetails.dob,
            PartnerEmergency: data.patientDetails.partnerDetails.phone,
            EmergencyAddress: data.patientDetails.partnerDetails.adharNumber,
          },
          medicalInformation: {
            referralSource: data.patientDetails.referralDetails.appliedThrough,
            referringPhysician:
              data.patientDetails.referralDetails.referringPhysician,
            referringPhysicianPhone:
              data.patientDetails.referralDetails.referringPhysicianPhone,
            referringPhysicianAddress:
              data.patientDetails.referralDetails.referringPhysicianAddress,
          },
          insuranceDetails: {
            InsuranceCompany:
              data.patientDetails.insuranceDetails.InsuranceCompany,
            PolicyNumber: data.patientDetails.insuranceDetails.PolicyNumber,
            GroupNumber: data.patientDetails.insuranceDetails.GroupNumber,
            ClaimsAddress: data.patientDetails.insuranceDetails.ClaimsAddress,
            InsuranceCity: data.patientDetails.insuranceDetails.InsuranceCity,
            InsuranceState: data.patientDetails.insuranceDetails.InsuranceState,
            InsuranceZip: data.patientDetails.insuranceDetails.InsuranceZip,
            Insurancephone: data.patientDetails.insuranceDetails.Insurancephone,
          },
        });
        setFiles(data.files);
        setLoading(false);
      } catch (error) {
        toast.error('Failed to fetch patient details');
        console.error('Error fetching patient details:', error);
      }
    };

    fetchPatientDetails();
  }, [id]);
  console.log(patientFormData, 'patientFormData');
  return (
    <div className="theme-blush">
      <div>
        <div className="container-fluid">
          <PageHeader
            HeaderText="View Patient Details"
            Breadcrumb={[{ name: 'View Patient Details' }]}
          />
        </div>
        <div className="registration-vertical-align-wrap">
          <div className="vertical-align-middle registration-form">
            <div style={{ padding: '50px' }}>
              {/* <div className="top">
                <img
                  src={Logo}
                  alt="Blomboss Logo"
                  style={{ width: '150px', margin: '10px' }}
                />
              </div> */}
              <form>
                <BasicDetails
                  patientFormData={patientFormData}
                  setPatientFormData={setPatientFormData}
                  disabled={true}
                />
                <GuarantorInformation
                  patientFormData={patientFormData}
                  setPatientFormData={setPatientFormData}
                  disabled={true}
                />
                <PartnerInformationForm
                  patientFormData={patientFormData}
                  setPatientFormData={setPatientFormData}
                  disabled={true}
                />
                <MedicalReferralInformation
                  patientFormData={patientFormData}
                  setPatientFormData={setPatientFormData}
                  disabled={true}
                />
                <InsuranceDetailsForm
                  patientFormData={patientFormData}
                  setPatientFormData={setPatientFormData}
                  disabled={true}
                />
              </form>
              <ImageGalleryProfile files={files} />
            </div>
          </div>
        </div>
      </div>
      {loading && <LoadingOverlay message="Fetching Patient Details..." />}
    </div>
  );
};

export default ViewPatient;
